<template>
  <div class="userCenter_right">
    <div class="title_div">
      <span
        class="title_left"
        :style="dialogFormVisible ? 'color:#808080;' : 'color:#2d50a1'"
        >成员管理</span
      >
      <i class="el-icon-arrow-right" v-show="dialogFormVisible"></i>
      <span class="title_left" v-show="dialogFormVisible">{{
        dialogFormTitle
      }}</span>
    </div>
    <div v-show="!dialogFormVisible">
      <div class="title_input">
        <div class="title_input_left demo-input-size">
          <p class="title_input_left_p">用户名称:</p>
          <el-input
            v-model="userName"
            size="small"
            style="width:200px;"
            placeholder="请输入用户名称"
          ></el-input>
        </div>
        <div class="title_input_left demo-input-size">
          <p class="title_input_left_p">电话:</p>
          <el-input
            v-model="phone"
            size="small"
            style="width:200px;"
            placeholder="请输入电话"
          ></el-input>
        </div>
        <div class="title_input_left demo-input-size">
          <p class="title_input_left_p">部门:</p>
          <el-cascader
            style="width: 300px;"
            size="small"
            v-model="orgCode"
            :options="departmentName"
            :props="{ checkStrictly: true,value:'code' }"
            clearable
          ></el-cascader>
        </div>
        <div class="title_input_left demo-input-size">
          <p class="title_input_left_p">状态:</p>
          <el-select
            v-model="state"
            size="small"
            clearable
            placeholder="请选择"
          >
            <el-option label="启用" value="ENABLE" />
            <el-option label="停用" value="DISABLE" />
          </el-select>
        </div>
        <div class="demo-input-size">
          <el-button
            style="margin-left: 30px;"
            type="primary"
            @click="getEnterpriseUserList"
            size="small"
            plain
            >搜索</el-button
          >
          <el-button
            @click="getClearMsg"
            class="chongzhi"
            size="small"
            plain
            >重置</el-button
          >
        </div>
        <!-- <div class="title_input_left demo-input-size">
          部门:
          <el-cascader
            style="width: 300px;"
            v-model="orgUuid"
            :options="departmentName"
            :props="{ checkStrictly: true }"
            clearable
          ></el-cascader>
          状态:
          <el-select
            v-model="state"
            size="small"
            clearable
            placeholder="请选择"
          >
            <el-option label="启用" value="ENABLE" />
            <el-option label="停用" value="DISABLE" />
          </el-select>
          <el-button
            style="margin-left: 30px;"
            type="primary"
            @click="getEnterpriseUserList"
            size="small"
            plain
            >搜索</el-button
          >
        </div> -->
      </div>
        <div class="title_input_right demo-input-size">
          <el-button
            title="添加"
            type="success"
            style="padding: 5px;"
            @click="addMemberUser"
            icon="el-icon-circle-plus"
            circle
          ></el-button>
          <el-button
            type="success"
            style="padding: 5px;"
            @click="downloadTemplate"
            icon="el-icon-download"
            circle
            title="下载模板"
          ></el-button>
          <el-upload
            action="/service-center/api/v1/user/staff/batchUploadUserStaff"
            :show-file-list="false"
            :headers="headers"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            :on-success="handleBannerSuccess"
            :before-upload="beforeBannerUpload"
            class="bannerImgClass"
            style="margin-left: 10px"
          >
            <el-button
              type="primary"
              style="padding: 5px;"
              icon="el-icon-link"
              circle
              title="导入"
            ></el-button>
          </el-upload>
        </div>
      <div class="tableContent" style="padding: 0 18px 20px;">
        <el-table
          ref="singleTable"
          :data="tableData"
          border
          style="width: 100%"
        >
          <el-table-column
            label="序号"
            type="index"
            width="55"
            style="text-align: center"
          >
          </el-table-column>
          <el-table-column property="name" label="成员名称"> </el-table-column>
          <el-table-column property="orgName" label="部门"> </el-table-column>
          <el-table-column property="tel" label="电话" width="130">
          </el-table-column>
          <el-table-column property="mail" label="邮箱"> </el-table-column>
          <el-table-column sortable label="状态" width="100">
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row.survival == 'ENABLE'"
                type="success"
                disable-transitions
                >{{ scope.row.survivalCn }}
              </el-tag>
              <el-tag
                v-if="scope.row.survival == 'DISABLE'"
                type="warning"
                disable-transitions
                >{{ scope.row.survivalCn }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" width="170">
            <template slot-scope="scope">
              {{ scope.row.createdDate.substring(0, 10) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="130">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="updateMemberUser(scope.row)"
                size="small"
                >修改</el-button
              >
              <el-button
                type="text"
                v-if="scope.row.survival == 'ENABLE'"
                @click="disableUser(scope.row.uuid)"
                size="small"
                >停用
              </el-button>
              <el-button
                type="text"
                v-if="scope.row.survival == 'DISABLE'"
                @click="enableUser(scope.row.uuid)"
                size="small"
                >启用
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 10px;text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-sizes="[5, 10, 20, 50]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <div v-show="dialogFormVisible" class="addApplication">
      <el-form :model="form" :rules="rules" ref="formRef">
        <el-form-item label="姓名" :label-width="formLabelWidth" prop="name">
          <el-input
            v-model="form.name"
            style="width: 300px;"
            placeholder="请输入姓名"
          ></el-input>
        </el-form-item>

        <el-form-item label="联系电话" :label-width="formLabelWidth" prop="tel">
          <el-input
            :disabled="!updateTel"
            type="tel"
            v-model="form.tel"
            style="width: 300px;"
            placeholder="请输入联系电话"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="电子邮件"
          :label-width="formLabelWidth"
          prop="mail"
        >
          <el-input
            type="email"
            v-model="form.mail"
            style="width: 300px;"
            placeholder="请输入电子邮件"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="密码"
          :label-width="formLabelWidth"
          prop="password"
        >
          <el-input
            type="password"
            v-model="form.password"
            style="width: 300px;"
            placeholder="请输入密码"
          ></el-input>
          <span style="color:red;" v-show="!form.uuid"
            >不填写密码则为默认密码,默认密码:sby@2023</span
          >
        </el-form-item>

        <el-form-item
          label="部门名称"
          :label-width="formLabelWidth"
          prop="orgUuid"
          v-if="departmentName.length"
        >
          <el-cascader
            style="width: 300px;"
            v-model="form.orgUuid"
            :options="departmentName"
            :props="{ checkStrictly: true }"
            clearable
          ></el-cascader>
        </el-form-item>

        <el-form-item label="性别" :label-width="formLabelWidth" prop="gender">
          <el-radio-group v-model="form.gender">
            <el-radio label="MALE" value="MALE">男</el-radio>
            <el-radio label="FEMALE" value="FEMALE">女</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelDialogForm">取 消</el-button>
        <el-button type="primary" @click="saveMemberUser('formRef')"
          >确 定</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import {
  disableUser,
  enableUser,
  getEnterpriseUserList,
  getNewcurrent,
  saveMemberUser,
  getOrganizationDeptTree,
  existsUser,
} from "../../../utils/interface";
export default {
  name: "index",
  data() {
    let checkPhoneNumber = async (rule, value, callback) => {
      let param = {
        userUuid: this.form.uuid,
        username: this.form.tel,
      };
      let phone = /^[1][3-9]\d{9}$/;
      let resSuccess;
      if (this.form.tel) {
        let res = await existsUser(param);
        resSuccess = res;
      }
      if (!this.form.tel) {
        callback(new Error("请填写手机号"));
      } else if (!phone.test(this.form.tel)) {
        callback(new Error("请输入正确的手机号码"));
      } else if (resSuccess) {
        callback(new Error("该用户已存在"));
      }
    };
    return {
      imageUrl: "",
      dialogFormTitle: "",
      rules: {
        name: [
          { required: true, message: "请输入成员名称", trigger: "change" },
        ],
        tel: [
          { required: true, message: "请填写电话", trigger: "change" },
          {
            pattern: /^[1][3-9]\d{9}$/,
            message: "请输入正确的手机号码",
          },
          {
            validator: checkPhoneNumber,
            trigger: "blur",
          },
        ],
        mail: [
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"],
          },
        ],
        gender: [{ message: "请选择性别", trigger: "change" }],
        orgUuid: [
          { required: true, message: "请选择部门名称", trigger: "change" },
        ],
      },
      form: {
        uuid: "",
        name: "",
        tel: "",
        password: "admins",
        mail: "",
        gender: "",
        orgUuid: "",
      },
      departmentName: [],
      softwareTypeList: [],
      currentPage4: 1,
      total: 0,
      pageSize: 10,
      formLabelWidth: "120px",
      dialogFormVisible: false,
      tableData: [],
      userDetail: {},
      applicationList: [],
      changeRow: {},
      multipleSelection: [],
      userName: "",
      orgUuid: "",
      orgCode: '',
      phone: "",
      mail: "",
      state: "",
      updateTel: true,
      headers: {
        Authorization: "Bearer " + this.$cookies.get("api_access_token"),
      },
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    getClearMsg(){
      this.userName = ''
      this.phone = ''
      this.orgUuid = ''
      this.orgCode = '';
      this.state = ''
      this.getEnterpriseUserList()
    },
    init() {
      this.userName = "";
      this.orgUuid = "";
      this.orgCode = "";
      this.phone = "";
      this.mail = "";
      this.state = "";
      this.currentPage4 = 1;
      this.getNewcurrent();
      this.getEnterpriseUserList();
      this.getOrganizationDeptTree();
    },
    // 查询部门
    getOrganizationDeptTree() {
      let param = {};
      getOrganizationDeptTree(param).then((response) => {
        this.departmentName = response.filter((items) => {
          return items.survival !== "DISABLE";
        });
      });
    },
    disableUser(uuid) {
      disableUser(uuid).then((response) => {
        this.getEnterpriseUserList();
      });
    },
    enableUser(uuid) {
      enableUser(uuid).then((response) => {
        this.getEnterpriseUserList();
      });
    },
    getEnterpriseUserList() {
      if (this.orgCode instanceof Array) {
        this.orgCode = this.orgCode[this.orgCode.length - 1];
      }
      let param = {
        enterpriseUuid: this.userDetail.enterpriseUuid,
        //userId: this.userDetail.uuid,
        survival: this.state,
        tel: this.phone,
        mail: this.mail,
        name: this.userName,
        orgCode: this.orgCode,
        current: this.currentPage4,
        pageSize: this.pageSize,
      };
      getEnterpriseUserList(param).then((response) => {
        this.tableData = response.list;
        this.total = response.total;
      });
    },
    handleSelectionChange(val) {
      // console.log(val)
      this.multipleSelection = val;
    },
    setCurrent(row) {
      this.$refs.singleTable.setCurrentRow(row);
    },
    updateMemberUser(row) {
      if (this.$refs.formRef) {
        this.$refs.formRef.resetFields();
      }
      this.dialogFormTitle = "编辑成员";
      this.updateTel = false;
      this.dialogFormVisible = true;
      this.imageUrl = row.logoUrl;
      this.form = row;
    },
    addMemberUser() {
      if (this.$refs.formRef) {
        this.$refs.formRef.resetFields();
      }
      this.dialogFormTitle = "添加成员";
      this.updateTel = true;
      this.form = {};
      this.imageUrl = "";
      this.dialogFormVisible = true;
    },
    cancelDialogForm() {
      this.dialogFormVisible = false;
      this.getEnterpriseUserList();
    },
    saveMemberUser(formName) {
      // let onsubmit = true;
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.dialogFormVisible = false;
          if (this.form.orgUuid instanceof Array) {
            this.form.orgUuid = this.form.orgUuid[this.form.orgUuid.length - 1];
          }
          saveMemberUser(this.form).then((res) => {
            if (res.success) {
              this.form = {};
              this.imageUrl = "";
              this.getEnterpriseUserList();
              this.$message({
                message: "保存成功",
                type: "success",
                customClass: "zZindex",
              });
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          this.$message.error('请填写完整信息');
        }
      });
    },
    openUrl(row) {
      window.open(row.deployUrl);
    },
    getNewcurrent() {
      if (!this.$store.state.isLogin) {
        this.$router.push({ name: "login", params: { uuid: uuid } });
        return;
      }
      getNewcurrent().then((res) => {
        this.userDetail = res;
        this.getEnterpriseUserList();
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getEnterpriseUserList();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      window.scrollTo(0, 0);
      this.getEnterpriseUserList();
    },
    downloadTemplate() {
      let a = document.createElement("a");
      a.href = "/static/people.xlsx";
      a.download = "用户模板.xlsx";
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      a.remove();
    },

    handleBannerSuccess(res) {
      this.loading = false;
      if (!res.success) {
        let message = res.message + "<br>";
        if (res.data != null) {
          res.data.forEach((item) => {
            message += item + "<br>";
          });
        }
        this.$message({
          dangerouslyUseHTMLString: true,
          message: message,
          type: "error",
        });
      } else {
        this.getEnterpriseUserList();
        this.getOrganizationDeptTree();
      }
    },
    beforeBannerUpload(file) {
      this.loading = true;

      if (!/\.(xlsx|xls|XLSX|XLS)$/.test(file.name)) {
        this.$message.warning("上传文件只能为excel文件，且为xlsx,xls格式!");
        this.loading = false;
        return false;
      }
    },
  },
};
</script>

<style scoped lang="less">
.addApplication {
  padding: 20px 50px;

  .dialog-footer {
    text-align: center;

    /deep/ .el-button--primary {
      background-color: #2d50a1;
      border-color: #2d50a1;

      &:hover {
        background: #66b1ff;
        border-color: #66b1ff;
      }
    }
  }
}
.tableContent {
  /deep/ .el-table .el-table__cell {
    padding: 5px 0;
  }
}
.zZindex {
  position: relative;
  z-index: 999;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.userCenter_right {
  width: 966px;
  background: #fff;

  h4 {
    color: #2d50a1;
    padding: 20px 18px;
    border-bottom: 2px solid #f9f9f9;
  }
  .title_div {
    padding: 20px 18px;
    border-bottom: 2px solid #f9f9f9;
  }
  .title_input {
    padding: 20px 18px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .title_input_left {
    font-size: 14px;
    display: flex;
    align-items: center;
    margin-right: 15px;
    .title_input_left_p {
        white-space: nowrap;
        margin-right: 15px;
    }
    // /deep/.el-input--small,/deep/.el-cascader--small {
    //     width: 136px !important;
    // }
  }
  .demo-input-size {
    margin-bottom: 10px;
    // /deep/.el-button--primary.is-plain {
    //   color: #2d50a1;
    //   border-color: #2d50a1;
    //   &:hover {
    //     background-color: #2d50a1;
    //     color: #fff;
    //   }
    // }
    .chongzhi:hover {
      border-color: #2d50a1;
      color: #2d50a1;
    }
  }
  .title_input_right {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    margin-right: 20px;
  }
  .title_left {
    font-weight: bold;
    color: #2d50a1;
  }
  .title_right {
    float: right;
    margin-right: 30px;
  }

  .userCenter_right_box {
    padding: 30px 18px;
    .formItem {
      display: flex;
      margin-bottom: 30px;
      position: relative;
      .title {
        width: 150px;
        line-height: 40px;
        letter-spacing: 1px;
        color: #494a4c;
      }
      .inputClass {
        width: 70%;
      }
    }
    .buttonGroupClass {
      text-align: right;
      button {
        padding: 8px 12px;
        background-color: #2d50a1;
        border-color: #2d50a1;
        &:hover {
          background-color: #4a96f1;
          border-color: #4a96f1;
        }
        i {
          padding-right: 5px;
          font-size: 14px;
        }
      }
    }
  }
}
/deep/.el-pager li.active {
  // color: #2d50a1;
}
</style>



// WEBPACK FOOTER //
// src/components/registeredLogin/memberManage/index.vue